import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import DesignRush from "../components/DesignRush";
import Services from "../components/Services";
import CaseStudies from "../components/CaseStudies";
import Pricing from "../components/Pricing";
import StatsAndProcess from "../components/StatsAndProcess";
import Testimonials from "../components/Testimonials";
import TrustedClients from "../components/TrustedClients";
import VideoTestimonials from "../components/VideoTestimonials";
import Contact from "../components/Contact";
import Cursor from "../components/Cursor";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
    return (
        <div className="text-white min-h-screen relative z-10">
            <Navbar />
            <Hero isHome={true} />
            <Cursor />
            <main className="relative z-10 w-full">
                <About />
                <DesignRush />
                <Services />
                <CaseStudies />
                <Pricing />
                <StatsAndProcess />
                <VideoTestimonials />
                <Testimonials />
                <TrustedClients />
                <Contact />
                <CTA />
                <Footer />
                <WhatsAppButton />
            </main>
        </div>
    );
};


export default Home;